import '@modifi/plugin-authentication/register'
import '@modifi/plugin-countries/register'
import '@modifi/plugin-user/register'
import '@modifi/plugin-notifications/register'
import {init as i18nInit} from '@modifi/plugin-i18n/register'
import '@modifi/plugin-banners/register'
import '@modifi/plugin-trade/register'

export const initPlugins = (options = {}) => Promise.all([i18nInit(options?.i18n)])
